export default () => `gem install flagsmith
`
